import { Box, Grid, Typography, Chip } from "@material-ui/core";
import { filterTableStrings } from "./StringBundle";
import { useGlobalStyles } from "./globalStyles";

const defaultGetLabel = (item) => `${item?.searchedTitle}:  ${item?.searchText}`;

// title and getLabel default to the table-filter text (FiltersTable / NestedTable); other screens can
// reuse the same removable chips with their own title (null hides it) and label.
// onSelect switches the chips to pick-one mode: no heading, no ×; the caller sizes the chips.
function FilterChip({
  filterSettings = [],
  clearFilterSettings = undefined,
  title = filterTableStrings.filterApplied,
  getLabel = defaultGetLabel,
  selectedIndex = undefined,
  onSelect = undefined,
}) {
  const globalClasses = useGlobalStyles();

  if (!filterSettings?.length) return null;

  return (
    <Box className={`${globalClasses.margins} ${globalClasses.pt10}`}>
      <Grid container className={globalClasses.displayctrl}>
        {!onSelect && title && (
          <Grid item>
            <Typography variant="body1" className={globalClasses.filterApplied}>
              {title}
            </Typography>
          </Grid>
        )}

        {filterSettings?.map((item, index) => (
          <Grid item key={index}>
            {onSelect ? (
              <Chip
                label={<>{item?.searchedTitle}<span>{item?.searchText}</span></>}
                clickable
                aria-pressed={index === selectedIndex}
                onClick={() => onSelect(index)}
                className={`${globalClasses.filterChip} ${index === selectedIndex ? globalClasses.filterChipSelected : ""}`}
              />
            ) : (
              <Chip
                label={getLabel(item)}
                onDelete={() => clearFilterSettings(index)}
                className={globalClasses.filterChip}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default FilterChip;
